import React from 'react';
import { useSale } from '@sls-react/contexts/SaleContext';
import dynamic from 'next/dynamic';
import useMobile from '@sls-react/hooks/useMobile';
import useV1Session from '@sls-react/hooks/useV1Session';

const SaleBanner = dynamic(
  () => import('@sls-react/components/Chrome/Banners/SaleBanner'),
);

const VacationModeBanner = dynamic(
  () => import('@sls-react/components/Chrome/Banners/VacationModeBanner'),
);

const CsvImportReminderBanner = dynamic(
  () => import('@sls-react/components/Chrome/Banners/CsvImportReminderBanner'),
);

const GetTheAppBanner = dynamic(
  () => import('@sls-react/components/Chrome/Banners/GetTheAppBanner'),
);

const RestrictedBanner = dynamic(
  () => import('@sls-react/components/Chrome/Banners/RestrictedBanner'),
);

const BannerCollection: React.FC = () => {
  const sales = useSale();
  const mobile = useMobile();

  const { data: v1Session } = useV1Session();

  if (v1Session?.user?.state === 'restricted') {
    return <RestrictedBanner />;
  }

  if (v1Session?.user.active_vacation) {
    return (
      <>
        {mobile && <GetTheAppBanner />}
        <VacationModeBanner vacation={v1Session.user.active_vacation} />
      </>
    );
  }

  if (v1Session?.user.features?.find(f => f.slug === 'import_items')) {
    return (
      <>
        {mobile && <GetTheAppBanner />}
        <CsvImportReminderBanner
          lastImportTime={v1Session.user.last_imported_at}
        />
      </>
    );
  }

  if (sales.showBanner) {
    return (
      <>
        {mobile && <GetTheAppBanner />}
        <SaleBanner />
      </>
    );
  }

  if (mobile) {
    return <GetTheAppBanner />;
  }

  return null;
};

export default BannerCollection;
